var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25002 6.49973C0.697739 6.49971 0.250013 6.94742 0.25 7.4997C0.249987 8.05199 0.697691 8.49971 1.24998 8.49973L1.25002 6.49973ZM23.4571 8.20737C23.8476 7.81685 23.8476 7.18369 23.4571 6.79315L17.0933 0.42904C16.7028 0.0385063 16.0696 0.0384911 15.6791 0.429006C15.2886 0.819521 15.2886 1.45269 15.6791 1.84322L21.3358 7.50021L15.6788 13.1569C15.2883 13.5474 15.2882 14.1806 15.6788 14.5711C16.0693 14.9617 16.7024 14.9617 17.093 14.5712L23.4571 8.20737ZM1.24998 8.49973L22.75 8.50024L22.75 6.50024L1.25002 6.49973L1.24998 8.49973Z",
    fill: "#F7971E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.03b78f1728fe4f025e0aa52626024590.svg";
export { ForwardRef as ReactComponent };